// BR-01 product boundaries only. Pricing remains a separate NCR calculation slice.
export const INDIVIDUAL_MAX_AMOUNT = 8000;
export const INDIVIDUAL_MAX_MONTHS = 6;
// Business-supplied Experian purpose catalogue. Values are labels, not provider GUIDs.
export const INDIVIDUAL_LOAN_PURPOSES = [
  'Consolidation Loan', 'Consumption', 'Co-Operative', 'Death / Funeral', 'Debt',
  'Furniture', 'Home Loans', 'Income Loss', 'Insurance', 'Living Expenses',
  'Loss - Theft or Fire', 'Medical', 'Other', 'Other Asset acquisition financing',
  'Other Emergency', 'Retirement', 'Security', 'Service', 'Small Business', 'Study Loan', 'Vehicle'
];
// Mirror the existing API schedule, not a newly approved individual repayment policy.
export function currentInstallmentEnd(value: string, count: number): string {
  const start = new Date(`${value}T00:00:00Z`);
  if (!value || !Number.isFinite(start.getTime()) || !Number.isInteger(count) || count < 1) return '';
  const offset = (start.getUTCDate() <= 15 ? 0 : 1) + count - 1;
  return new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + offset + 1, 0)).toISOString().slice(0, 10);
}
export function addCalendarMonths(value: string, months: number): string {
  const start = new Date(`${value}T00:00:00Z`);
  if (!value || !Number.isFinite(start.getTime())) return '';
  const last = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + months + 1, 0));
  return new Date(Date.UTC(last.getUTCFullYear(), last.getUTCMonth(),
    Math.min(start.getUTCDate(), last.getUTCDate()))).toISOString().slice(0, 10);
}
export function individualProductErrors(loan: any = {}): Array<{ field: string; message: string }> {
  const errors: Array<{ field: string; message: string }> = [];
  const add = (field: string, message: string) => errors.push({ field, message });
  if (!INDIVIDUAL_LOAN_PURPOSES.includes(loan.loanPurpose))
    add('loanPurpose', 'Select a loan purpose from the list.');
  if (!Number.isFinite(loan.loanAmount) || loan.loanAmount <= 0 || loan.loanAmount > INDIVIDUAL_MAX_AMOUNT)
    add('loanAmount', 'Individual loan amount must be greater than zero and cannot exceed R8,000.');
  if (loan.securityType !== 'UNSECURED') add('securityType', 'Individual loans must be unsecured.');
  if (!['ONCE_OFF', 'INSTALLMENTS'].includes(loan.customLoanType)) add('customLoanType', 'Select a payment type.');
  if (loan.customLoanType === 'INSTALLMENTS' && (!Number.isInteger(loan.numberOfInstallments) ||
      loan.numberOfInstallments < 1 || loan.numberOfInstallments > INDIVIDUAL_MAX_MONTHS))
    add('numberOfInstallments', 'Select between 1 and 6 monthly installments.');
  const limit = addCalendarMonths(loan.commencementDate, INDIVIDUAL_MAX_MONTHS);
  if (!limit || !loan.dueDate || !Number.isFinite(Date.parse(loan.dueDate)) || loan.dueDate <= loan.commencementDate || loan.dueDate > limit)
    add('dueDate', 'Repayment must be after commencement and within six calendar months.');
  return errors;
}
